export default __webpack_public_path__ + "static/media/content-3-transparent.d8d4cd30.png";